import { render, staticRenderFns } from "./traffic-order.vue?vue&type=template&id=0127a44c&"
import script from "./traffic-order.vue?vue&type=script&lang=js&"
export * from "./traffic-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports